import React, { useState } from 'react';
import { MainPageContent } from './MainPageContent';

const MainPage = () => {
  return (
    <>
      <MainPageContent />
    </>
  );
};

export default MainPage;
